import React from 'react'
import './List_view_dashboard.css'
import Search_total_project from '../search-total-project/Search_total_project'
import { Link, useNavigate } from 'react-router-dom'
import { faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const List_view_dashboard = () => {

    const data = [
        {
            card_title: "Ongoing Installations",
            no: "99",
            innerdata: [
                {
                    label: "Shamshabad, AMXL :",
                    value: "50 cam"
                },
                {
                    label: "Hyderabad, Zero Mile :",
                    value: "12 cam"
                },
                {
                    label: "Chakan, DP World :",
                    value: "50 cam"
                },
                {
                    label: "Kolkata, Meesho :",
                    value: "150 cam"
                },

            ]
        },

        {
            card_title: "Rental Installations",
            no: "99",
            innerdata: [
                {
                    label: "Shamshabad, AMXL :",
                    value: "50 cam"
                },
                {
                    label: "Hyderabad, Zero Mile :",
                    value: "12 cam"
                },
                {
                    label: "Chakan, DP World :",
                    value: "50 cam"
                },
                {
                    label: "Kolkata, Meesho :",
                    value: "150 cam"
                },

            ]
        },

        {
            card_title: "Installations under AMC",
            no: "99",
            innerdata: [
                {
                    label: "Shamshabad, AMXL :",
                    value: "50 cam"
                },
                {
                    label: "Hyderabad, Zero Mile :",
                    value: "12 cam"
                },
                {
                    label: "Chakan, DP World :",
                    value: "50 cam"
                },
                {
                    label: "Kolkata, Meesho :",
                    value: "150 cam"
                },

            ]
        },

        {
            card_title: "Installation Under Warrenty",
            no: "99",
            innerdata: [
                {
                    label: "Shamshabad, AMXL :",
                    value: "50 cam"
                },
                {
                    label: "Hyderabad, Zero Mile :",
                    value: "12 cam"
                },
                {
                    label: "Chakan, DP World :",
                    value: "50 cam"
                },
                {
                    label: "Kolkata, Meesho :",
                    value: "150 cam"
                },

            ]
        },


    ]

    const navigate = useNavigate()

    return (
        <>
            <section className='List_view_dashboard'>
                <div className='innersectionflex'>
                    <div className='countrybox'>
                        <div className='section_box '>

                            <p className='blue_heading'>View List</p>

                            <div className='cards_holder'>
                                <div className='row'>

                                    {data?.map((item, index) => {

                                        const gradients = [
                                            'linear-gradient(0deg, #c6ffee, #defff1)',
                                            'linear-gradient(0deg, #e4ccfd, #ecdaff)',
                                            'linear-gradient(0deg, #fad1d7, #fee8eb)',
                                            'linear-gradient(0deg, #c2e6ff, #e2f3ff)',
                                        ];
                                        const cardStyle = {
                                            background: gradients[index % gradients.length]
                                        };

                                        const headergradients = [
                                            '#61AC93',
                                            '#BB80FF',
                                            '#D8878F',
                                            '#33AAFF',
                                        ];
                                        const headrercardStyle = {
                                            background: headergradients[index % headergradients.length]
                                        };

                                        const cardNoGradient = [
                                            '#079266',
                                            '#803FCB',
                                            '#D94F5D',
                                            '#2270A8',
                                        ];
                                        const cardNoStyle = {
                                            background: cardNoGradient[index % headergradients.length]
                                        };

                                        return (
                                            <div className='col-lg-6'>
                                                <div className='col_holder'>
                                                    <div className='card card_bg' style={cardStyle}>

                                                        <div className='heading_div' style={headrercardStyle}>
                                                            <div className='row align-items-center'>

                                                                <div className='col-xxl-10  col-md-9'>
                                                                    <div className='card_title_div'>
                                                                        <p className='title_text'>{item?.card_title}</p>
                                                                    </div>
                                                                </div>
                                                                <div className='col-xxl-2 col-md-3'>
                                                                    <div className='card_no_div' style={cardNoStyle}>
                                                                        <p className='no_text'>{item?.no}</p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>

                                                        <div className='body_div'>
                                                            {item?.innerdata?.map((innerData) => {
                                                                return (
                                                                    <div className='innerdata_holder'>
                                                                        <p className='label_text'>{innerData?.label}</p>
                                                                        <p className='value_text'>{innerData?.value}</p>
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                    </div>
                                                    <div className='view_div' onClick={() => { navigate("/ongoing-installations") }}>
                                                        <p className='view_text'>View All</p>
                                                        <div className='icon_holder'>
                                                            <FontAwesomeIcon icon={faAngleRight} className="icon" />
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='totalprojectsidebar'>
                        <div className='right_sidebar'>
                            <Search_total_project />
                            <br></br>
                            <br></br>
                            <div className='listdashbtn_div'>
                                <div className='btngroup'><Link to="/" ><button className='listbtn'>Map View</button></Link></div>
                                <div className='btngroup'><Link to="/dashboard-view"><button className='dashbtn theme_bg'>Dashboard</button></Link></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default List_view_dashboard